import { createUseStyles } from 'react-jss';
import { getFocusBoxShadow } from '../focus';
export const disabledButtonOpacity = 0.4;
export const useButtonClasses = createUseStyles({
    button: (props) => ({
        borderRadius: props.theme.components.button.sizes[props.size || 'medium'].borderRadius,
        cursor: props.isDisabled ? 'default' : 'pointer',
        outline: 'none',
        textDecoration: 'none',
        backgroundSize: '100% 100%, cover',
        border: props.variant === 'primary' ? 'none' : '1px solid transparent',
        borderColor: props.variant === 'secondary' ? props.theme.colors.sea : undefined,
        opacity: props.isDisabled ? disabledButtonOpacity : undefined,
        pointerEvents: props.isDisabled ? 'none' : undefined,
        height: props.theme.components.button.sizes[props.size || 'medium'].height,
        padding: props.variant === 'ghost' ? undefined : props.theme.components.button.sizes[props.size || 'medium'].padding,
        background: props.theme.components.button.variants[props.variant || 'primary'].background,
        color: props.theme.components.button.variants[props.variant || 'primary'].color,
        '&:focus-visible': {
            boxShadow: props.variant === 'ghost' ? undefined : getFocusBoxShadow(props.theme),
            textDecoration: props.variant === 'ghost' ? 'underline' : 'none',
            color: props.theme.components.button.variants[props.variant || 'primary'].colorFocused,
        },
        '&:hover': {
            background: props.theme.components.button.variants[props.variant || 'primary'].backgroundHovered,
            backgroundSize: '250% 250%, cover',
            textDecoration: props.variant === 'ghost' ? 'underline' : 'none',
            color: props.theme.components.button.variants[props.variant || 'primary'].colorHovered,
        },
    }),
    '@media (prefers-reduced-motion: no-preference)': {
        button: {
            transitionProperty: 'background-size, background-color, color, border-color',
            transitionDuration: '0.36s',
            transitionTimingFunction: 'ease-in-out',
        },
    },
});
